import { COLORS } from '@repo/design-system/index'
import { QIcon_effect } from '@repo/icons/index'
import { useAITutorStreak } from '../../../modules/apis/student/ai-tutor'
import { n_ai_tutor } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ReactComponent as FireActive } from '../../common/icons/fire_active.svg'
import { ReactComponent as FireInactive } from '../../common/icons/fire_inactive.svg'
import { AITutorStreakCard } from './AITutorCard'

const AITutorStreakInfo = ({ active }) => {
  const { t } = useTranslation()

  return (
    <div className={`bg-white rounded-[8px] px-[12px] py-[8px] w-full`}>
      <div className="flex flex-row gap-[8px]">
        <div>
          <QIcon_effect color={active ? COLORS.YELLOW300 : COLORS.PURPLE400} width={20} height={20} />
        </div>
        <div className="Body2-14Md text-gray-600">{t(n_ai_tutor.acheivement.msg3)}</div>
      </div>
    </div>
  )
}

const AITutorStreak = () => {
  const { t } = useTranslation()
  const { data: streakData } = useAITutorStreak()

  const today = streakData?.streak?.is_today_streak
  const streak = streakData?.streak?.streak || 0

  return (
    <div className="p-16 space-y-16">
      <section
        className={`${
          today ? 'border-yellow-100 bg-[#FFFCF0]' : 'border-gray-200 bg-gray-50'
        } rounded-[16px] border-[1.5px] p-[16px] flex flex-col gap-[20px] items-start justify-start self-stretch`}
      >
        <div className="flex flex-row gap-[12px] items-center justify-start self-stretch">
          <div className="flex flex-col items-start justify-start flex-1">
            <div
              className={`${
                today ? 'bg-red-50' : 'bg-purple-50'
              } rounded px-[6px] py-[2px] flex flex-row items-start justify-start`}
            >
              <div className={`${today ? 'text-red-400' : 'text-purple-500'} text-left Caption-12Bd`}>
                {t(n_ai_tutor.acheivement.streak)}
              </div>
            </div>
            <div className="flex flex-row items-end justify-start self-stretch pt-[6px]">
              <div
                className={`${
                  today ? 'text-black' : 'text-gray-400'
                } text-center Headline1-28Bd flex items-end justify-center`}
              >
                {t(n_ai_tutor.acheivement.day(streak))}
              </div>
            </div>
            <div className="flex flex-row items-end justify-start self-stretch pt-[4px]">
              <div className="text-gray-600 text-left Body2-14Md flex-1 flex items-end justify-start">
                {today ? t(n_ai_tutor.acheivement.msg2) : t(n_ai_tutor.acheivement.msg1)}
              </div>
            </div>
          </div>
          {today ? <FireActive width={80} height={80} /> : <FireInactive width={80} height={80} />}
        </div>
        <AITutorStreakInfo active={today} />
      </section>
      <AITutorStreakCard streak={streak} />
    </div>
  )
}

export default AITutorStreak
